import { createSelector } from '@ngxs/store';
import { TransactionsState } from './transactions.state';

export class TransactionsSelectors {
  static transactionsById = createSelector(
    [TransactionsState.transactions],
    (transactions) => transactions.byId
  );
}
